{
  "customers_search_table": {
    "load_error": "Unable to load customers. Please try again.",
    "search_bar": {
      "placeholder": "Search…"
    }
  },
  "customers_table": {
    "default_caption": "Your customers",
    "headings": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "group": "Group",
      "billing_address": "Billing address"
    },
    "row": {
      "billing_address_not_set": "No billing address"
    }
  },
  "sales_agent_availability_alert": {
    "variants": {
      "none_in_plan": {
        "title": "Sales agents are not included in your plan",
        "description": "Your plan does not have access to our sales agents feature. If you would like to gain access, please upgrade your plan."
      },
      "none_remaining": {
        "title": "Your plan includes {max_sales_agents, plural, =1 {1 sales agent} other {# sales agents}}",
        "description": "You have used all of your available sales agents. Please upgrade your plan to add more."
      },
      "is_remaining": {
        "title": "Your plan includes {max_sales_agents, plural, =1 {1 sales agent} other {# sales agents}}",
        "description": "You've assigned {used_sales_agents, number} of {max_sales_agents, plural, =1 {# sales agent} other {# sales agents}}. You can manage sales agents under \"Customers\"."
      }
    },
    "actions": {
      "go_to_customers": "View customers",
      "add_agents": "Add more agents"
    }
  },
  "customer_role_selection_card": {
    "header": "Role",
    "description": "Assign a role to manage permissions for this person.",
    "roles_load_error": {
      "title": "Unable to load roles",
      "description": "Something went wrong loading the roles list. Please refresh the page."
    },
    "main": {
      "label": "Customer",
      "description": "Can log in and place orders."
    },
    "sales_agent": {
      "label": "Sales agent",
      "description": "Can place orders and manage addresses, shopping lists, and company access on behalf of customers."
    },
    "sales_admin": {
      "label": "Sales administrator",
      "description": "All sales agent permissions, plus the ability to edit order prices and create new customers."
    },
    "custom": {
      "description": "This is a custom role."
    },
    "save_role": "Save role",
    "restrict_sales_agent_groups_access_alert": {
      "title": "Restrict sales agent access",
      "description": "If you want sales agents to only see specific customers, you can set these below using groups.",
      "placeholder": "Select group(s) - leave empty to allow access to all customers",
      "error": {
        "title": "Unable to load sales agent groups",
        "description": "Something went wrong loading sales agent groups. Please reload the page or contact support if the issue persists."
      }
    },
    "notifications": {
      "error": {
        "role_update_failed": "Failed to update role to \"{role}\""
      },
      "success": {
        "role_update_succeeded": "Role updated to \"{role}\""
      }
    }
  },
  "customer_financials_card": {
    "header": "Financial details",
    "discount_percentage": "Discount percentage",
    "accounting_id": "Accounting ID",
    "payment_on_account": {
      "label": "Payment on account",
      "balance": "Balance",
      "credit_limit": "Credit limit",
      "net_terms": "Net terms",
      "currency": "Currency"
    }
  },
  "customer_addresses_card": {
    "header": "Addresses",
    "default_shipping": "Default shipping address",
    "default_billing": "Default billing address",
    "other_addresses": "Other addresses"
  },
  "customer_company_users_card": {
    "header": "Company users",
    "description": "All users associated with this customer and their roles.",
    "table": {
      "headings": {
        "name": "Name (email)",
        "role": "Role"
      },
      "caption": "Company users"
    },
    "alerts": {
      "error": {
        "title": "Unable to load company users",
        "description": "Something went wrong loading company users. Please reload the page or contact support if the issue persists."
      },
      "not_set": {
        "title": "No company users assigned",
        "description": "Add company users to enable shared order history, shopping lists, and addresses."
      },
      "not_enabled": {
        "description": "Company users are not currently enabled. Enable this feature in your settings if needed."
      }
    }
  },
  "customer_identifier_card": {
    "header": "Identifiers",
    "platform_id": "Platform ID",
    "sparklayer_id": "SparkLayer ID",
    "legacy_id": "Legacy ID",
    "internal_id": "Internal ID"
  },
  "customer_advanced_details_card": {
    "header": "Advanced details"
  }
}
